import httpClient from '../../api';

export default () => ({
  namespaced: true,
  actions: {
    async fetch() {
      const { data: { data } } = await httpClient.get('countries');
      return data;
    },
  },
});
